import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { updateervaringen, getervaringen } from "../Reducers/actions";
import { message } from "../../../Reducers/loading/actions";
import LogboekEditForm from "../Components/communicatie";
import { Link, useParams, useNavigate } from "react-router-dom";
import SneaTabs from "../../../Components/SneaTabs";
const ErvaringenEditESPage = ({ updateervaringen, getervaringen, message }) => {
  const [loaded, setLoaded] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  const submit = (vals) => {
    updateervaringen(params.id, vals).then((data) => {
      if (data.type === "FACILIEIT_ERROR") {
        alert(data.payload);
        return false;
      } else {
        message(3000, "success", "De ervaring is met succes aangepast").then((data) => {
          navigate("/ervaringen/edit/" + params.id);
        });
      }
    });
  };

  const tabs = [
    {
      id: 'wat',
      label: 'Wat',
      content: null
    },
    {
      id: 'waar',
      label: 'Waar',
      content: null
    },
    {
      id: 'media',
      label: 'Media',
      content: null
    },
    {
      id: 'beschikbaarheid',
      label: 'Beschikbaarheid',
      content: null
    },
    {
      id: 'eigenschappen',
      label: 'Eigenschappen',
      content: null
    },
    {
      id: 'communicatie',
      label: 'Communicatie',
      content: loaded && <LogboekEditForm onSubmit={submit} />
    }
  ];

  const handleTabChange = (tabId, index) => {
    const routes = {
      'wat': `/ervaringen/edit/${params.id}`,
      'waar': `/ervaringen/edit/waar/${params.id}`,
      'media': `/ervaringen/edit/media/${params.id}`,
      'beschikbaarheid': `/ervaringen/edit/beschikbaarheid/${params.id}`,
      'eigenschappen': `/ervaringen/edit/eigenschappen/${params.id}`,
      'communicatie': `/ervaringen/edit/communicatie/${params.id}`
    };
    if (routes[tabId]) {
      navigate(routes[tabId]);
    }
  };
  useEffect(() => {
    setLoaded(false);
    getervaringen(params.id).then((data) => {
      if (data.results) {
        setLoaded(true);
      } else {
        message(3000, "warning", "Er is een fout opgetreden bij het laden van de activiteit").then((data) => {
          navigate("/logboek");
        });
      }
    });
  }, [getervaringen, params.id, message]);

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title"> Ervaring wijzigen</h3>
      </div>
      <div className="row">
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body wizard">
              <SneaTabs
                tabs={tabs}
                defaultActiveTab={5}
                variant="default"
                onTabChange={handleTabChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return { username: state.auth.user, ervaringen: state.ervaringen.item };
}

export default connect(mapStateToProps, {
  updateervaringen,
  getervaringen,
  message,
})(ErvaringenEditESPage);
